import { useState, useEffect } from "react";
import Config from "../../Config";


import InputUploader from "../../helpers/InputUploader";
import InputPassword from "../../helpers/InputPassword";


function Account(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);
    const [row, setRow] = useState({
        haslo: "",
        moje_haslo: "",
    });

    const [errTab, setErrTab] = useState([]);  //z info od serwera..


    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,account', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {           
                    props.mainView.setProgress(-1);  
                    setTab(res);        
         } )
         .catch(err => {          
                    props.mainView.setProgress(-1);
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }


    const saveAwatar = (cr) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            crypt: cr
        };

        fetch( Config.url + '/rest_v1,save_awatar', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {           
                    props.mainView.setProgress(-1);  
                    getData();    
         } )
         .catch(err => {          
                    props.mainView.setProgress(-1);
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;
    }




    const completeUpload = (fileName, crypt) => {    
        console.log("completeUpload " + fileName + " " + crypt);
        saveAwatar(crypt);; 
    }



    const valChangeListener = (filedName, val, correct, msg) => {

        
        if(filedName == 'e_mail_kontakt') return;

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        var tabCheck = filedName.split('@');
        if(tabCheck.length == 2)
        {
            var tabName = tabCheck[0];
            var tabInx  = tabCheck[1];
            var tRef = row[tabName];
            if(correct)tRef[tabInx] = val;
            if(!correct)tRef[tabInx] = "";

            setRow( {...row, [tabName]:tRef } );   
            return;
        }

        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }   



     
    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }



    const valChange = (filedName, val, correct, msg) => {

        //  console.log("valChange: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
        setTab( {...tab, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }

    const goNext = () => {
        console.log("goNext");
    }




    const saveData = () => {


        if(row.haslo.length < 8)
        {
            var filedName = 'haslo';
            setRow( {...row, [filedName]:'',  [filedName+"_valid"]:false } );   
            return;
        }
        

        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }

        props.mainView.setProgress(-2);

        var req = row;

        fetch( Config.url + '/rest_v1,save_password', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane", "ok" , null);                                               
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }









    if(tab == null)
    {
        setTab([]);
        getData();
        return (
            <div></div>
        );        
    }

    if(tab._sys_ == undefined) //no correct response..
    {
        return (
            <div></div>
        );   
    }


    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        getData();
    }

 



    return (
             <div className="view_content">
                  <h1>Moje konto / {tab.result.imie} {tab.result.nazwisko} </h1>

                  <form className="eForm bg_center">

                  <div className="form_control">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                <img className="pl_logo" src={ "data:image/jpeg;base64, " + tab.result.awatar} />
                                </td>
                                <td>
                                  <InputUploader   userData={props.userData}  typ="none" typId="-1" remove="0" completeUpload={completeUpload} title="zmień zdjęcie profilowe" max_files="1" ext="image/png, image/jpeg" />
                                </td>
                            </tr>
                        </tbody>                        
                    </table>
                                
                                
                   </div>


                   <div className="form_tab">
                            <div className="form_tab_title">Placówka</div>
                     
                            <div className="form_control">
                                <div className="fieldName">Aktualnie pracujesz na:</div>
                                &nbsp;
                                <b>{tab.result.pl.nazwa}</b>
                            </div>
                   </div>

                   <div className="form_tab">
                            <div className="form_tab_title">Autoryzacja</div>


                            <div className="form_control">
                                <div className="fieldName">Moje hasło do panelu, którym się loguje:</div>
                                <InputPassword    userData={props.userData}  value={row.moje_haslo}  err={errTab} valChange={valChangeListener} goNext={goNext} name="moje_haslo" placeholder={"Moje hasło do panelu: "} className=' w100' req='1' />
                            </div>

                            <div className="form_split"></div>
                            
                 

                            <div className="form_control">
                                <div className="fieldName">Login dyrektora</div>
                                <span><b>{tab.result.e_mail} </b></span>
                            </div>

                            <div className="form_split"></div>
                         
                            
                            <div className="form_control">
                                <div className="fieldName">Nowe hasło (Min. 8 znaków, cyfry, litery małe i duże, znaki specjalne !@#...)*</div>
                                <InputPassword    userData={props.userData}  value={row.haslo}  err={errTab}  valChange={valChangeListener} goNext={goNext} name="haslo" placeholder={"Hasło: "} className=' w100' req='1' rand="1" />
                            </div>
                    </div>


                    
                    <div className="form_split"></div>

                        <div className="form_btn">
                                <div className="btn" onClick={saveData}>zapisz</div>
                           
                        </div>




                  </form>


            </div>
        )
}


export default Account;